export default {
  notifications: {
    labels: {
      title: 'Recent Notifications',
    },
    buttons: {
      markAllAsRead: 'Mark all as read',
      settings: 'Settings',
    },
    emptyState: {
      title: 'No Notifications',
      description: 'Notifications keep you informed of any changes or updates to your jobs. Go post a job to get started!'
    }
  },
  messages: {
    header: {
      title: 'Messages',
    },
    content: {
      duration: {
        hours: '%hours% hours ago',
        days: '%days% days ago',
      }
    },
    footer: {
      viewAll: 'View All'
    },
    emptyState: {
      title: 'No Messages',
      description: 'Messages are your way of communicating with Wonoloers. Go to the manage jobs page to get started!'
    }
  }
};
